import React from 'react';

import Header from './Header';

import Topbar from './TopBar';

import Footer from './Footer';

import Privacypage from "./Privacypage";

const Privacy = () => {
    
    return(
        <div>
            <Header/>
            <Topbar/>
            <Privacypage/>
            <Footer/>
           
        </div>
        
    );
};

export default Privacy;